<div class="activity-details" c-toggle="showActivity">
    <div class="activity-details solo">
        <c-auto-form config="autoFormConfig"></c-auto-form>
    </div>
</div>